import React from 'react';
import HotTable from 'react-handsontable';
import {FormInline} from '../fragments/forms';
import Button from '../fragments/button';

import style from './style.css';


export default class DataSheetView extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      loading: true,
      columns: [],
      colHeaders: [],
      data: [],
      nonEditable: [],
      unsaved: [],
      unsavedChangeOnly: false
    };
  }

  componentDidMount() {
    window.addEventListener('message', ({data, origin}) => {
      if (origin !== window.location.origin) {
        return;
      }
      const {action, payload} = data;
      if (action !== 'setDataSheet') {
        return;
      }
      const unsaved = [...payload.data];
      this.setState({
        ...payload, unsaved, loading: false,
        unsavedChangeOnly: false});
    });
    window.opener.postMessage({
      action: 'dataSheetReady'
    }, window.location.origin);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !nextState.unsavedChangeOnly;
  }

  handleSave() {
    const {unsaved} = this.state;
    for (let i = unsaved.length - 1; i >= 0; i --) {
      if (Object.keys(unsaved[i]).length === 0) {
        unsaved.splice(i, 1);
      }
    }
    window.opener.postMessage({
      action: 'updateData',
      data: unsaved
    }, window.location.origin);
    window.close();
  }

  handleChange(changes) {
    if (changes === null) {
      return;
    }
    const {unsaved} = this.state;
    for (const [rowidx, prop,, newVal] of changes) {
      while (unsaved.length <= rowidx) {
        unsaved.push({});
      }
      const row = {...unsaved[rowidx]};
      if (newVal === '') {
        delete row[prop];
      }
      else {
        row[prop] = newVal;
      }
      unsaved[rowidx] = row;
    }
    this.setState({unsaved, unsavedChangeOnly: true});
  }

  setHeight() {
    return window.innerHeight - 175;
  }

  render() {
    let {data, columns, colHeaders, loading, nonEditable} = this.state;
    columns = columns.map((column) => {
      if (nonEditable.includes(column.data)) {
        column.editor = false;
      }
      return column;
    });
    return <div>
      <FormInline>
        <Button
         btnStyle="primary" pullRight
         disabled={loading}
         onClick={this.handleSave.bind(this)}>
          Save and Close Window
        </Button>
      </FormInline>
      <div ref="container" className={style.sheetContainer}>
        {data && data.length ?
          <HotTable
           root="hot"
           width="100%"
           height={this.setHeight.bind(this)}
           autoWrapCol
           autoWrapRow
           manualRowMove
           manualColumnMove
           manualRowResize
           manualColumnResize
           minSpareRows={10}
           stretchH="all"
           data={data}
           columns={columns}
           colHeaders={colHeaders}
           onAfterChange={this.handleChange.bind(this)}
           contextMenu={true}
           rowHeaders
         /> : null}
      </div>
    </div>;
  }

}



// WEBPACK FOOTER //
// ./src/views/datasheet/index.js